import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'src/components/common/Modal'
import clsx from 'clsx'
import CloseButton from 'src/components/house/BtnClose'

const ModalHouseCommon = ({
  open,
  onClose,
  children,
  height = 'max-h-[90%]',
  isContainedByModal = true
}) => {
  const Container = isContainedByModal ? Modal : 'div'
  const containerProps = isContainedByModal
    ? {
        open,
        onClose,
        className: 'w-full flex items-center justify-center',
        maxHeight: 'h-full'
      }
    : {}

  return (
    <Container {...containerProps}>
      <div
        className={clsx(
          height,
          'relative w-full max-w-[95%] bg-cream flex flex-col border-4 border-stone-gray font-Inter rounded-[20px]'
        )}
        style={{ boxShadow: '0px 4px 4px 0px #00000040' }}
      >
        <CloseButton onClose={onClose} />
        {children}
      </div>
    </Container>
  )
}

ModalHouseCommon.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  isContainedByModal: PropTypes.bool,
  height: PropTypes.string
}

export default ModalHouseCommon
